import { onError } from 'apollo-link-error'
import { history } from 'labguard-cdk'
import { showSplashscreenMessage } from 'src/services/splashscreen'

/**
 * Defines a GraphQL interceptor dedicated to error handling (e.g authentication).
 */
export default onError(({ networkError, graphQLErrors = [] }) => {
  // handle network errors (unreachable backend)
  if (networkError) {
    console.error(networkError)
    // this can't be translated because we don't have messages from the server
    showSplashscreenMessage('Could not connect to server')
  }
  // handle functional errors
  else {
    graphQLErrors.forEach(({ extensions = {} }) => {
      switch (extensions.code) {
        // redirect to login on any 401 code
        case '401': {
          if (history.location.pathname !== '/login') {
            history.replace({ pathname: '/login', state: { from: history.location } })
          }
          break
        }
        default:
          break
      }
    })
  }
})
